<template>
  <div
    class="order-item-wrap"
    :class="{
      'electron-order-item-wrap': isElectron,
    }"
  >
    <!-- 头部信息 -->
    <div class="order-top">
      <!-- 左 -->
      <div>
        <span v-if="orderInfo.charge_at" class="charge-at"
          >支付时间：{{
            moment(orderInfo.charge_at * 1000).format("YYYY-MM-DD HH:mm:ss")
          }}</span
        >
        <span class="order-no">交易单号：{{ orderInfo.order_no }}</span>
      </div>
      <!-- 订单状态 -->
      <div class="order-status">
        <!-- 报名成功 -->
        <template v-if="signUpSuccess">
          <img
            class="status-icon"
            src="../../../../assets/images/trade/dui-icon.png"
            alt=""
          />
          <span class="status-text success">报名完成</span>
        </template>
        <!-- 待支付 -->
        <template v-else-if="orderInfo.state === 1">
          <img
            class="status-icon"
            src="../../../../assets/images/trade/pay-icon.png"
            alt=""
          />
          <span class="status-text wait">
            待支付&nbsp;
            <CountDown
              class="countdown"
              :callback="callback"
              v-if="orderInfo.sub_order_list && orderInfo.sub_order_list.length"
              :type="2"
              :endTime="orderInfo.sub_order_list[0].timeout_at"
              endText=""
            />
          </span>
        </template>
        <!-- 订单关闭 -->
        <template v-else-if="handleFailTips">
          <img
            class="status-icon"
            src="../../../../assets/images/trade/cuo-icon.png"
            alt=""
          />
          <span class="status-text fail">{{ handleFailTips }}</span>
        </template>
        <!-- 待成团 -->
        <template v-else-if="orderInfo.group_state === 1">
          <img
            class="status-icon"
            src="../../../../assets/images/trade/wait-icon.png"
            alt=""
          />
          <span class="status-text wait-group">待成团</span>
        </template>
      </div>
    </div>
    <!-- 课程列表 -->
    <div
      v-if="orderInfo.sub_order_list && orderInfo.sub_order_list.length"
      class="course-list-wrap"
    >
      <!-- 课程总数+展开收起 -->
      <div class="num-wrap">
        <button v-if="!showMore && showMoreBtn" @click="showMoreCourse">
          <span>共&nbsp;{{ orderInfo.sub_order_list.length }}&nbsp;门课程</span>
          <i class="el-icon-arrow-down"></i>
        </button>
        <button v-else-if="showMoreBtn && showMore" @click="closeMoreCourse">
          <span>共&nbsp;{{ orderInfo.sub_order_list.length }}&nbsp;门课程</span>
          <i class="el-icon-arrow-up"></i>
        </button>
      </div>
      <div class="list-wrap">
        <div
          v-for="item in orderInfo.sub_order_list.slice(0, length)"
          :key="item.goods_id + item.order_no"
          class="course-item"
        >
          <div @click="jumpProductDetail(item.course_id)" class="course-wrap">
            <img
              class="cover"
              :src="
                handleImageUrl(item.goods_cover_url) + '?imageView2/0/w/180'
              "
              alt=""
            />
            <div class="course-info">
              <p class="title">
                {{ item.goods_title }}
              </p>
              <p class="course-id">ID：{{ item.course_id }}</p>
            </div>
          </div>

          <!-- 单个课-操作 -->
          <div class="btns-wrap">
            <button
              v-if="signUpSuccess"
              @click="showUseDetail(item)"
              class="normal-text-btn usage-detail"
            >
              使用详情
            </button>
            <button
              @click="goGroupInfo"
              v-if="
                (signUpSuccess &&
                  orderInfo.activity_type === 4 &&
                  orderInfo.activity_id) ||
                (!signUpSuccess && showGroupInfoBtn)
              "
              class="normal-text-btn"
            >
              拼团详情
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部操作区 -->
    <div class="order-bottom">
      <div class="left-wrap">
        <div class="operate-btns">
          <button
            v-if="signUpSuccess && orderInfo.is_past_refund_time"
            @click="refund(orderInfo)"
            class="cancel-btn"
          >
            申请退款
          </button>
          <!-- 未报名成功 -->
          <template v-if="!signUpSuccess">
            <button
              v-if="
                orderInfo.activity_type === 4 &&
                orderInfo.group_state === 1 &&
                orderInfo.state === 2 &&
                orderInfo.reply_result === 0 &&
                !handleFailTips
              "
              @click="groupRefund"
              class="cancel-btn"
            >
              取消拼团
            </button>
            <button
              v-else-if="orderInfo.state === 1"
              @click="handleCancelOrder"
              class="cancel-btn"
            >
              取消订单
            </button>
          </template>
        </div>
        <div v-if="orderInfo.remark" class="notes-info">
          备注：{{ orderInfo.remark }}
        </div>
      </div>
      <div class="right-wrap">
        <!-- 价格 -->
        <div class="price-wrap">
          <!-- 支付方式 -->
          <p v-if="showPayType" class="channel">
            {{ payType[orderInfo.channel] || "" }}
          </p>
          <!-- 订单总价 -->
          <p class="total-price">
            {{ formatPrice(orderInfo.real_price) }}
          </p>
        </div>
        <button
          v-if="showInputAddressBtn"
          @click="inputAddress(orderInfo)"
          class="primary-btn"
        >
          填写地址
        </button>
        <button
          v-if="showViewAddressBtn"
          @click="inputAddress(orderInfo)"
          class="primary-btn info-btn"
        >
          地址信息
        </button>
        <template v-if="!signUpSuccess">
          <button
            v-if="orderInfo.state === 1"
            @click="jumpPayment"
            class="primary-btn danger-btn"
          >
            立即支付
          </button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import orderItem from "../mixins/order-item.js";
export default {
  mixins: [orderItem],
};
</script>

<style lang="scss" scoped>
.order-item-wrap {
  background: var(--card-bg, #ffffff);
  border-radius: 12px;
  border: 1px solid var(--border-subtle, #efefef);
  margin-bottom: 23px;
  .order-top {
    border-radius: 12px 12px 0 0;
    background: var(--input-bg, #f7f8f9);
    height: 50px;
    padding: 0 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .charge-at,
    .order-no {
      font-size: 12px;
      color: var(--text-primary, #0d1400);
      line-height: 17px;
    }
    .charge-at {
      margin-right: 40px;
    }
    .order-status {
      display: flex;
      align-items: center;
    }
    .status-icon {
      width: 14px;
      height: 14px;
      margin-right: 4px;
    }

    .status-text {
      font-weight: 500;
      font-size: 12px;
      line-height: 1;
      &.success {
        color: #00c89d;
      }
      &.wait {
        color: #f03349;
        display: flex;
        align-items: center;
      }
      &.wait-group {
        color: #ff7d00;
      }
      &.fail {
        color: var(--text-secondary, #515350);
      }
    }
  }
  // 课程列表
  .course-list-wrap {
    border-radius: 12px;
    border: 1px solid var(--border-subtle, #efefef);
    margin: 12px 16px 12px;
    padding: 8px 16px 0;
    .num-wrap button {
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 12px;
      color: #00c89d;
      line-height: 17px;
      margin-bottom: 2px;
      i {
        margin-left: 8px;
        font-weight: 600;
        font-size: 11px;
        color: #00c89d;
        line-height: 1;
      }
    }
  }
  // 单个课
  .course-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 14px;

    &:first-child {
      border-bottom: none;
      padding-top: 6px;
    }
    .course-wrap {
      display: flex;
      cursor: pointer;
    }
    .cover {
      width: 94px;
      height: 53px;
      margin-right: 8px;
      border-radius: 8px;
      object-fit: cover;
    }
    .course-info {
      max-width: 700px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .title {
      width: 100%;
      font-weight: 500;
      font-size: 12px;
      color: var(--text-primary, #0d1400);
      line-height: 17px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .course-id {
      font-size: 12px;
      color: var(--text-secondary, #747573);
      line-height: 17px;
    }
    // 操作
    .btns-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        margin-right: 10px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .order-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 18px 0 14px;
    .notes-info {
      font-weight: 400;
      font-size: 12px;
      color: var(--text-secondary, #747573);
      line-height: 17px;
      padding-left: 5px;
    }
    .left-wrap,
    .right-wrap,
    .price-wrap {
      display: flex;
      align-items: center;
      & > div {
        margin-bottom: 12px;
      }
      & > button {
        margin-bottom: 12px;
      }
    }
    .left-wrap {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      .operate-btns {
        margin-bottom: 0;
        button {
          margin-bottom: 12px;
        }
      }
    }
    .price-wrap {
      .channel {
        font-size: 12px;
        color: var(--text-primary, #0d1400);
        line-height: 17px;
        margin-right: 8px;
      }
      .total-price {
        font-weight: 500;
        font-size: 16px;
        color: var(--text-primary, #0d1400);
        line-height: 22px;
      }
    }
    .right-wrap {
      button {
        margin-left: 15px;
      }
    }
  }

  .primary-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 25px;
    border-radius: 6px;
    border: 1px solid rgba(0, 200, 157, 0.2);
    font-weight: 500;
    font-size: 12px;
    color: #00c89d;
    line-height: 1;
    padding: 0 6px;
    &.danger-btn {
      color: #f03349;
      border: 1px solid #ffd5da;
    }
    &.info-btn {
      border: 1px solid var(--border-subtle, #efefef);
      color: var(--text-primary, #0d1400);
    }
  }
  .normal-text-btn {
    font-size: 12px;
    color: var(--text-primary, #0d1400);
    line-height: 17px;
    padding: 5px;
  }
  .cancel-btn {
    font-weight: 400;
    font-size: 12px;
    color: var(--text-secondary, #747573);
    line-height: 17px;
    padding: 0 5px;
  }
}

// 桌面端
.electron-order-item-wrap {
}
</style>
